// app/src/features/submit/SubmitBar.jsx
import React from "react";
import AskHero from "../../components/AskHero.jsx";

/**
 * The frame's `hero` slot (the plan's `SubmitBar`): the new-question page's ask box over the lane
 * area, with the featured forecasts. Only on the empty state, and not while a question just asked
 * here is pending (its progress card stands in).
 */
export default function SubmitBar({ ctx }) {
  const {
    askHeroOn,
    heroPendingRun,
    askHeroSubmit,
    forecastEngine,
    orchestrators,
    handleSelectTier,
    quickDeepSelectorAllowed,
    railPanelOpen,
    featuredForecasts,
  } = ctx;
  return (
    <>
      {/* Empty-state hero / running-forecast status over the lane area */}
      {askHeroOn && !heroPendingRun && (
        <AskHero
          onSubmit={askHeroSubmit.submit}
          notice={askHeroSubmit.notice}
          onNoticeSeen={askHeroSubmit.clearNotice}
          forecastEngine={forecastEngine}
          orchestrators={orchestrators}
          onSelectTier={handleSelectTier}
          depthSelectorEnabled={quickDeepSelectorAllowed}
          leftInset={railPanelOpen ? "var(--rail-panel-w)" : 0}
          featured={featuredForecasts.featured}
          searchPool={featuredForecasts.searchPool}
          onOpenFeatured={featuredForecasts.openFeatured}
        />
      )}
    </>
  );
}
